import React from 'react';
import { inject, observer } from 'mobx-react';
import H5SidebarCherryPickList from './h5';
import PCSidebarCherryPickList from './pc';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import { withRouter, RouteComponentProps } from 'react-router-dom';

interface SidebarCherryPickListProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    thread?: ThreadAction;
}
interface SidebarCherryPickListState {
    indexRecommendThread: any
}
type SidebarCherryPickListAllProps = SidebarCherryPickListProps & RouteComponentProps;
@inject('app', 'site', 'user', 'thread')
@observer
// 下载APP入口，h5是悬浮在页面顶部，pc是放在页面内容右侧
class SidebarCherryPickList extends React.Component<SidebarCherryPickListAllProps, SidebarCherryPickListState> {
    constructor(props: SidebarCherryPickListAllProps) {
        super(props);

        // 从 props 中获取初始值设置到 state
        this.state = {
            indexRecommendThread: [],
        };
    }

    async componentDidMount() {
        // 可以在这里添加初始化逻辑
        // console.log('这是header');
        await this.getCherryPickList();
        
    }
    // 获取推荐帖子列表
    getCherryPickList = async () => {
        const { thread } = this.props;
        if (thread && thread.getIndexRecommendThread) {
            const res = await thread.getIndexRecommendThread({ 'page': 1, 'perPage': 10});
            // 转换为需要的格式
            console.log(res, '精选帖子数据');
            if(res.code == 0) {
                this.setState({ indexRecommendThread: res.data?.data });
            }
            
        }
    }
    // 点击更多，跳转到首页
    goHome = () => {
        this.props.history.push(`/`);
    }

    // 跳转到帖子详情
    threadClick = async (item) => {
        // this.props.history.push(`/threadDetail/${item.id}`);
        window.open(`/threadDetail/${item.id}`);
    }   

    render() {
        const { site, app, thread, ...props } = this.props;
        const { indexRecommendThread } = this.state;
        const platform = app?.platform || 'h5';
        
        if (platform === 'pc') {
            return <PCSidebarCherryPickList threadClick={(item:any) =>this.threadClick(item)} indexRecommendThread={indexRecommendThread} goHome={() =>this.goHome()} {...props} />;
        }
        
        return <H5SidebarCherryPickList {...props} />;

    }
}

export default withRouter(SidebarCherryPickList);